import React from 'react';

const NoShippingAddressFound = () => {
    return <div className="text-center">
        <img src={window.location.origin + "/images/please-add-your-shipping-details.png"} width="300" />
    </div>;
}

export default NoShippingAddressFound;